import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import StatusHandler from 'app/shared-components/StatusHandler'

import requests from 'app/requests/Quote/SimplifiedQuote.requests'
import {
    SimplifiedCQuote,
} from '../SimplifiedCQuotes.types'
import SimplifiedCQuoteForm from '../SimplifiedCQuoteForm'

export default function SimplifiedCQuoteUpdate({
    id,
}: Readonly<{ id: number }>) {
    const {
        data,
        isDataReady,
        isError,
        isFetching,
        error,
        invalidate,
    } = useRequest<SimplifiedCQuote>({
        key: RequestKeys.getSimplifiedCQuote,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: !!id,
        keepPreviousData: true,
    })

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isError={isError}
            error={error}
            isFetching={isFetching}
        >
            <SimplifiedCQuoteForm
                shortenMode
                data={data}
                requestParam={requests.update({
                    id,
                })}
                onSuccess={invalidate}
                onCancel={invalidate}
            />
        </StatusHandler>
    )
}
